export class Authority {
  id: number;
  mode: boolean;
  type: number;
  type1Select1: number; 	// 自然人著作 法人著作 選擇
  type1Input1: string;	  // 自然人著作 法人著作 輸入
  type1Select2: number;	  // 長期著作保護類型 短期著作 選擇
  type1Date: number;	    // 公開發表日期

  constructor() {
    this.type = null;
    this.type1Select1 = null;
    this.type1Select2 = null;
  }
}
